import type { InputHTMLAttributes } from 'react'
import styles from './Switch.module.css'

export function Switch(
  props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'role'>
) {
  return (
    <input {...props} type="checkbox" role="switch" className={styles.switch} />
  )
}
